<template>
  <div class="col-lg-4">
    <div class="card mb-4">
      <h3 class="card-title">{{ $t('common.cartridge') }}</h3>
      <div class="cartridge">
        <div class="row d-flex align-items-center">
          <div class="col-6 cartridge-fill">
            <div class="float-right">
              <img
                :src="iconFill"
                class="cartridge-icon"
                :alt="cartridgeFill"
              />
            </div>
          </div>
          <div class="col-6">
            <span v-if="cartridgeFill === 'full'">100%</span>
            <span v-else-if="cartridgeFill === 'half-full'">60%</span>
            <span
              v-else-if="
                cartridgeFill === 'almost-empty' || cartridgeFill === 'empty'
              "
              >10%</span
            >
            <span v-else>?</span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6 cartridge-type">
            <span v-show="cartridgeSize">
              {{ $t('common.cartridge') }}: {{ cartridgeSize }}ml</span
            >
          </div>
          <div class="col-6">
            <button
              v-if="buyingCustomer"
              @click="showShop"
              class="btn btn-primary float-right"
            >
              <MaterialSvg
                class="icon-white"
                name="shopping_basket"
                :width="24"
              />
              {{ $t('button.order') }}
            </button>
            <button
              v-if="!buyingCustomer"
              @click="showShop"
              class="btn btn-primary float-right"
            >
              {{ $t('button.request') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Getter as TokenGetter } from '@/store/session/types';
export default {
  name: 'Cartridge',
  data() {
    return {
      isModalVisible: false,
    };
  },
  props: {
    error: {
      type: Boolean,
      required: false,
    },
    cartridgeFill: {
      type: String,
      required: false,
    },
    hubId: {
      type: Number,
      required: true,
    },
    currentScent: {
      type: String,
      required: true,
    },
    cartridgeSize: {
      type: Number,
      required: false,
    },
  },
  computed: {
    subscriptionType() {
      return this.$store.state.user.subscription.code;
    },
    buyingCustomer() {
      return this.subscriptionType === 'K' || this.subscriptionType === 'I';
    },
    cartridgeType() {
      return this.cartridgeSize < 1000 ? 'cartridge' : 'jerrycan';
    },
    iconFill() {
      return (
        '/images/icons/' +
        this.cartridgeType +
        '_' +
        this.cartridgeFill +
        '.svg'
      );
    },
  },
  methods: {
    showShop() {
      if (this.buyingCustomer) {
        window.open(this.$t('shop.url'), '_blank');
      } else {
        this.$root.$emit('open', this.hubId, this.currentScent);
      }
    },
  },
};
</script>
